import { EventTypes } from '@racemap/sdk/schema/events';
import { useCurrentEvent } from './useCurrentEvent';

export function useIsSafemap() {
  const currentEvent = useCurrentEvent();
  return currentEvent?.type === EventTypes.SAFEMAP;
}
